import React from 'react'
import { useParams } from 'react-router-dom'
import useLoad from '../../eventsPublic/functions/useLoad'
import { loadExhibitor } from '../../eventsPublic/apis/publicApi'
import EventBreadcrumb from '../../eventsPublic/components/EventBreadcrumb'
import { EXHIBITOR, BREADCRUMB, LABELS } from '../constants/staticText'
import { useFileUrl } from '../functions/FileUrlContext'
import { useDocumentTitle } from '../../lib/a11y/useDocumentTitle'
import { useFocusHeading } from '../../lib/a11y/useFocusHeading'
import LoadingIndicator from '../../lib/components/LoadingIndicator'
import RichText from '../../lib/components/RichText'
import VisuallyHidden from '../../lib/a11y/VisuallyHidden'
import { bildMasse } from '../../lib/functions/bildMasse'
import { Messen, Berufe, Praktika, Stellen, Kontakt } from './ExhibitorProfileSections'

// Aussteller-Profilseite (#239), /aussteller/<id>/. Gestaltung aus dem Corporate
// Design der Stellenanzeige (job-detail-*): Kopfband, Name als Hauptueberschrift,
// Eckdaten, Logo rechts — darunter die Abschnitte. Der Server liefert das Profil
// jedes angezeigten Ausstellers, Messen und Berufe nur ueber sichtbare Messen.
const ExhibitorProfile = () => {
    const { id } = useParams()
    const fileUrl = useFileUrl()
    const { data, loading, error } = useLoad(() => loadExhibitor(id), [id])
    useDocumentTitle(data ? data.name : EXHIBITOR.banner)
    const headingRef = useFocusHeading(!loading && !!data)

    if (loading) return <LoadingIndicator label={EXHIBITOR.loading} />
    if (error || !data) {
        return (
            <div className="jobs-state" role="status">
                <p>{EXHIBITOR.notFound}</p>
                <p><a href="/events/">{EXHIBITOR.toEvents}</a></p>
            </div>
        )
    }

    const praktika = data.professions.filter(p => 'Praktikum' === p.type)
    const berufe = data.professions.filter(p => 'Praktikum' !== p.type)

    return (
        <>
            <EventBreadcrumb trail={[{ label: BREADCRUMB.start, to: '/', extern: true }, { label: data.name }]} />
            <article className="job-detail exhibitor-profile">
                <div className="job-detail-banner">{EXHIBITOR.banner}</div>

                <div className="job-detail-head">
                    <div className="job-detail-head-text">
                        <h1 tabIndex={-1} ref={headingRef}>{data.name}</h1>
                        {data.internship && (
                            <ul className="job-detail-facts">
                                <li className="job-detail-fact is-type">{EXHIBITOR.internship}</li>
                            </ul>
                        )}
                        {data.description && <RichText className="job-detail-company-text" html={data.description} />}
                        {data.website && (
                            <div className="job-detail-buttons">
                                <a className="job-detail-button is-website" href={data.website} target="_blank" rel="noreferrer">
                                    {LABELS.companyWebsite}
                                    <VisuallyHidden>{LABELS.opensNewTab}</VisuallyHidden>
                                </a>
                            </div>
                        )}
                    </div>
                    {data.logo && (
                        <div className="job-detail-logo">
                            <img src={fileUrl(data.logo.fileId)} alt={data.name} {...bildMasse(data.logo)} />
                        </div>
                    )}
                </div>

                <Messen events={data.events} />
                <Berufe professions={berufe} />
                <Praktika internship={data.internship} praktika={praktika} />
                <Stellen jobs={data.jobs} company={{ name: data.name, logo: data.logo }} />
                <Kontakt address={data.address} contact={data.contact} />
            </article>
        </>
    )
}

export default ExhibitorProfile
